import { configureStore } from "@reduxjs/toolkit";
import googleMapReducer from "./features/GoogleMaps/googleMapSlice";
import alertsReducer from "./features/Alerts/alertsSlice";
import userReducer from "./features/User/userSlice";
import homeReducer from "./features/Home/homeSlice";

export const store = configureStore({
    reducer: {
        googleMap: googleMapReducer,
        alerts: alertsReducer,
        user: userReducer,
        home: homeReducer,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
